import React from 'react';

const stats = [
  { label: '실시간 전략', value: '24 SET' },
  { label: '평균 모니터링', value: '1,200+ 신호' },
  { label: '지원 언어', value: 'KR · EN' },
];

const features = [
  '원클릭으로 진입·익절·헷지 시나리오 로드',
  '펀딩/변동성 조건을 반영한 자동 필터링',
  '직접 제어 가능한 시스템 설정',
  '모바일에서도 동일한 컨트롤 기능',
];

export default function Main() {
  return (
    <div className="main-container_main main-landing">
      <div className="main-landing__overlay" />

      <div className="main-landing__content">
        <section className="main-landing__intro">
          <p className="intro-badge">Bitgenstone AI Desk</p>
          <h1 className="intro-title">
            단 한 번의 선택으로<br />전략부터 체결까지.
          </h1>
          <p className="intro-subtitle">
            사용자에게 최적화된 자동매매 허브입니다.
            시장이 빠르게 변해도, 이곳에서 모든 전략을 중앙에서 관리하세요.
          </p>

          <div className="intro-stats">
            {stats.map((stat) => (
              <article className="intro-stat-card" key={stat.label}>
                <span className="intro-stat-value">{stat.value}</span>
                <span className="intro-stat-label">{stat.label}</span>
              </article>
            ))}
          </div>

          <div className="hero-actions">
            <button
              onClick={() => (window.location.href = '/SelectBitget')}
              className="hero-btn hero-btn--primary"
            >
              Bitget 콘솔 바로가기
            </button>
            <button
              onClick={() => (window.location.href = '/SelectBinance')}
              className="hero-btn hero-btn--secondary"
            >
              Binance 콘솔 열기
            </button>
          </div>
          <p className="hero-hint">* 계정 연결 후 각 거래소 전략을 바로 불러올 수 있어요.</p>
        </section>

        <section className="main-landing__panel">
          <div className="panel-card">
            <div>
              <p className="panel-label">Automation Highlights</p>
              <h3 className="panel-title">실시간 컨트롤 센터</h3>
              <p className="panel-subtitle">
                리스크 관리, 수익 극대화, 빠른 스위칭까지 모두 한 화면에서 처리하세요.
              </p>
            </div>

            <ul className="panel-list">
              {features.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>

            <div className="panel-divider" />

            <div className="panel-footer">
              <span>지원 거래소</span>
              <div className="panel-chips">
                <span>Bitget</span>
                <span>Binance</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}